import { IamAuthProvider } from "@itaas/core/auth/IamAuthProvider";
import { pharmacySessionApi } from "@/auth/pharmacy-auth.service";
import { SUITE_URL } from "@/core/config";

interface PharmacyAuthProviderProps {
  children: React.ReactNode;
}

export function PharmacyAuthProvider({ children }: PharmacyAuthProviderProps) {
  return (
    <IamAuthProvider api={pharmacySessionApi} moduleId="hospitol" suiteUrl={SUITE_URL}>
      {children}
    </IamAuthProvider>
  );
}

/** Alias métier Hospitol (legacy imports) */
export const HospitolAuthProvider = PharmacyAuthProvider;
